'use strict';

var React = require('react');

var SvgLayoutLogoBlockIcon = function SvgLayoutLogoBlockIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 6.25a2.75 2.75 0 0 1 2.75-2.75.75.75 0 0 1 0 1.5c-.69 0-1.25.56-1.25 1.25a.75.75 0 0 1-1.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 16.5a2.75 2.75 0 0 1-2.75-2.75.75.75 0 0 1 1.5 0c0 .69.56 1.25 1.25 1.25a.75.75 0 0 1 0 1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6.25a2.75 2.75 0 0 0-2.75-2.75.75.75 0 0 0 0 1.5c.69 0 1.25.56 1.25 1.25a.75.75 0 0 0 1.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13.75a2.75 2.75 0 0 1-2.75 2.75.75.75 0 0 1 0-1.5c.69 0 1.25-.56 1.25-1.25a.75.75 0 0 1 1.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 9a.75.75 0 0 0-1.5 0v2a.75.75 0 0 0 1.5 0v-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 8.25a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 5a.75.75 0 0 0 0-1.5h-2a.75.75 0 0 0 0 1.5h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 15.75a.75.75 0 0 1-.75.75h-2a.75.75 0 0 1 0-1.5h2a.75.75 0 0 1 .75.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 9a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3v-2Zm3-1.5h2a1.5 1.5 0 0 1 1.5 1.5v2a1.5 1.5 0 0 1-1.5 1.5h-2a1.5 1.5 0 0 1-1.5-1.5v-2a1.5 1.5 0 0 1 1.5-1.5Z"
  }));
};
SvgLayoutLogoBlockIcon.displayName = "LayoutLogoBlockIcon";

exports.SvgLayoutLogoBlockIcon = SvgLayoutLogoBlockIcon;
